import _MpButton from "./MpButton.jsx"
import withInstall from "../../utils/withInstall"
export const MpButton = withInstall(_MpButton)
export default MpButton
